import React from 'react';
import styled from 'styled-components';
import { ICollectionSortOption, IOption } from '@/interfaces/index';

import { Typography } from '@material-ui/core';
interface ISortCollectionMobile {
  sortSelected: {
    value: string;
    label: string;
  } | null;
  sortChangeHandler: (option: ICollectionSortOption) => void;
  collectionSortOptions: IOption[];
}
interface IStyledProps {
  active?: boolean;
  shadow?: boolean;
}

const UlComponent = styled.ul<IStyledProps>`
  padding: 8px 0;
  overflow-x: auto;
  display: flex;
  cursor: pointer;
`;

const LiComponent = styled.li<IStyledProps>`
  width: 140px;
  height: 35px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  background-color: ${props =>
    props.active ? props.theme.paletteDefault.offWhite : 'inherit'};
`;

const WrapperDiv = styled.div<IStyledProps>`
  box-shadow: ${props =>
    props.shadow
      ? '1px 1px 1px 1px ' + props.theme.paletteDefault.grey1
      : 'none'};
  padding: 4px 0;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
`;

const SortCollectionMobile: React.FC<ISortCollectionMobile> = ({
  sortSelected,
  sortChangeHandler,
  collectionSortOptions,
}) => {
  let header = (
    <Header>
      <Typography component="h1" style={{ fontWeight: 600 }}>
        SORT BY
      </Typography>
    </Header>
  );

  return (
    <WrapperDiv className={'customWrapper'}>
      {header}
      <UlComponent>
        {collectionSortOptions &&
          collectionSortOptions.map(option => {
            return (
              <LiComponent
                key={option.value}
                active={option.value === sortSelected?.value}
                onClick={() => sortChangeHandler(option)}>
                {option.label}
              </LiComponent>
            );
          })}
      </UlComponent>
    </WrapperDiv>
  );
};

export default SortCollectionMobile;
